import React from 'react';

import InlineBanner, {InlineBannerActionType, InlineBannerType} from 'ui-library/banners/InlineBanner';
import usePreference from 'ui-library/hooks/usePreference';

const INFERENCE_BANNER_PREFERENCE_KEY = 'model-hub-inference-banner-dismissed';
const BENCHLING_INFERENCE_BLOG_URL =
  'https://www.benchling.com/blog/announcing-benchling-inference-powered-by-baseten';

/**
 * Promotional banner pointing users with private models to the Benchling Inference offering.
 * Rendered inside a fixed-position wrapper in ScientificModelsView. Dismissible per-user.
 */
export default function ModelHubInferenceBanner(): JSX.Element | null {
  const [dismissed, setDismissed] = usePreference<boolean | undefined>(INFERENCE_BANNER_PREFERENCE_KEY);

  if (dismissed) {
    return null;
  }

  return (
    <InlineBanner
      bannerType={InlineBannerType.INFO}
      text="Have private models?"
      dataTestAttrs={{component: 'ModelHubInferenceBanner', element: 'root'}}
      action={{
        actionType: InlineBannerActionType.CUSTOM,
        actionText: 'Check out Benchling Inference',
        actionHref: BENCHLING_INFERENCE_BLOG_URL,
      }}
      onDismiss={() => {
        setDismissed(true);
      }}
    />
  );
}
